module.exports = __webpack_public_path__ + "static/16-fde72112982a0eec23cafeb74d5d0958.png";